module.exports = __webpack_public_path__ + "static/media/discontrol021.1a6e000e.jpg";